import { NavLink, useLocation, useNavigate } from "react-router-dom";

import style from "../../sass/components/header.module.scss";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUnpaidBillsCount } from "../../features/shipmentBills/shipmentBillsSlice";
import { useTranslation } from "react-i18next";
import SwitchLang from "../SwitchLang";

const Header = () => {
    const {t} = useTranslation();
    const [burgerOpened, setBurgerOpened] = useState(false);
    const location = useLocation()
    const upaidBillsCount = useSelector(selectUnpaidBillsCount)

    return (
        <>
            <header
                className="w-full fixed flex justify-between items-center px-14 shadow-2xl"
                style={{
                    height: 60,
                    zIndex: 100,
                    backgroundColor: "white",
                    borderRadius: "0 0 10px 10px",
                    maxWidth: 1366,
                }}
            >
                {/* Left */}
                <div className="flex gap-8">
                    <div className={`${style.logoContainer}`} style={{display: 'block', width: 100, height: 60}}>
                        <NavLink to="/" className={style.logoLink} style={{display: 'block', width: 100, height: 60}}>
                            <img
                                className={style.logo} 
                                src="/static/images/png/pony-express-logo.png" 
                                alt="logo" />
                        </NavLink>
                    </div>
                    <SwitchLang />
                </div>

                {/* Right */}
                <div className="relative">
                    <div className={`${style.wideScreen} w-full flex gap-6`}>
                        <NavLink
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/shipments" ? style.selected : "" }
                            `}
                            to="/shipments"
                        >
                            <span>{t("headbar.shipments")}</span>
                        </NavLink>
                        
                        <NavLink 
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/calc" ? style.selected : "" }
                            `}
                            to="/calc"
                        >
                            <span>{t("headbar.calculator")}</span>
                        </NavLink>
                        
                        <NavLink
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/shipment-bills" ? style.selected : "" }
                            `}   
                            to="/shipment-bills"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span className="relative">
                                {t("headbar.bills")}
                                {
                                    upaidBillsCount > 0 &&
                                    <div 
                                        className="absolute"
                                        style={{
                                            top: -2,
                                            right: -6,
                                            width: 11,
                                            height: 11,
                                            borderRadius: "50%",
                                            backgroundColor: "#b91c1c",
                                            color: "white",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: ".5rem",
                                            fontWeight: "bold",
                                        }}
                                    >{upaidBillsCount}</div>
                                }
                            </span>
                        </NavLink>

                        
                        <NavLink
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/saved-receivers" ? style.selected : "" }
                            `}   
                            to="/saved-receivers"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>{t("headbar.saved_receivers")}</span>
                        </NavLink>

                        <NavLink 
                            className={`
                                text-xs
                                ${style.linkBold} 
                                ${location.pathname === "/profile" ? style.selected : "" }
                            `}   
                            to="/profile"
                        >
                            <span>{t("headbar.user")}</span>
                        </NavLink>
                    </div>

                    <div
                        className={`${style.burgerMenuButton}`}
                        onClick={() => setBurgerOpened(!burgerOpened)}
                    >
                        <span
                            className={`${style.burgerLine} ${
                                style.burgerLine1
                            } ${burgerOpened ? style.checked : ""}`}
                        ></span>
                        <span
                            className={`${style.burgerLine} ${
                                style.burgerLine2
                            } ${burgerOpened ? style.checked : ""}`}
                        ></span>
                        <span
                            className={`${style.burgerLine} ${
                                style.burgerLine3
                            } ${burgerOpened ? style.checked : ""}`}
                        ></span>
                    </div>
                </div>
            </header>

            {/* Burger menu body */}
            <div
                className={`${style.burgerMenuBody} ${
                    burgerOpened ? style.active : ""
                }`}
            >
                <div
                    className="relative"
                    style={{
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <div
                        className="absolute inset-0 h-fit w-fit m-auto flex flex-col items-start gap-14"
                    >
                        <NavLink
                            className={`${style.linkBold} text-left`}
                            to="/shipments"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                {t('headbar.shipments')}
                            </span>
                        </NavLink>
                        <NavLink 
                            className={`${style.linkBold} text-left`} 
                            to="/calc"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                {t('headbar.calculator')}
                            </span>
                        </NavLink>
                        <NavLink
                            className={`${style.linkBold} text-left`}
                            to="/shipment-bills"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span className="relative">
                                {t('headbar.bills')}
                                {
                                    upaidBillsCount > 0 &&
                                    <div
                                        className="absolute"
                                        style={{
                                            top: -2,
                                            right: -6,
                                            width: 11,
                                            height: 11,
                                            borderRadius: "50%",
                                            backgroundColor: "#b91c1c",
                                            color: "white",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: ".5rem",
                                            fontWeight: "bold",
                                        }}
                                    >{upaidBillsCount}</div>
                                }
                            </span>
                        </NavLink>
                        <NavLink 
                            className={`${style.linkBold} text-left`} 
                            to="/saved-receivers"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                {t("headbar.saved_receivers")}
                            </span>
                        </NavLink>
                        <NavLink 
                            className={`${style.linkBold} text-left`} 
                            to="/profile"
                            onClick={() => setBurgerOpened(false)}
                        >
                            <span>
                                {t("headbar.user")}
                            </span>
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
